import { Button, Result } from "antd";
import { Component, type ErrorInfo, type ReactNode } from "react";
import { type WithTranslation, withTranslation } from "react-i18next";

interface ErrorBoundaryProps extends WithTranslation {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render(): ReactNode {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title={t("errorBoundary.title")}
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              {t("errorBoundary.reload")}
            </Button>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
